
import { deep_freeze } from "core/utils/deep_freeze"

import {
    aggregate_power_plants_by_h3r4_id,
    initial_power_plants_data,
    map_power_plants_by_h3r4_id,
} from "../../sim_3d/data/power_plants"
import { update_simulation_state_with_user_action } from "../../sim_3d/model/v3"
import { get_performant_state_reference } from "../../state_performant_accessor"
import { SetAppState } from "../interface"
import { PowerPlantsState } from "./interface"


export function initial_state(set_state: SetAppState): PowerPlantsState
{
    const initial_all_by_h3r4_cell = map_power_plants_by_h3r4_id(initial_power_plants_data)
    initial_all_by_h3r4_cell["8409a09ffffffff"]!.push({
        lat: 0,
        lon: 0,
        nameplate_capacity_MW: 20_000,
        storage_MWH: 100_000,
        // When was it commissioned
        operational_year: 2020,
        status: "operational",
        type: "battery",
    })
    const initial_aggregated_by_h3r4_id = deep_freeze(aggregate_power_plants_by_h3r4_id(initial_all_by_h3r4_cell))
    // const aggregated_by_h3r4_id = deep_copy(initial_aggregated_by_h3r4_id)

    return {
        // all: initial_power_plants_data,
        // all_by_h3r4_cell: map_power_plants_by_h3_cell(initial_power_plants_data),
        initial_aggregated_by_h3r4_id,
        // aggregated_by_h3r4_id,

        update_build_action: build_action =>
        {
            set_state(state =>
            {
                if (!state.simulation_state.sim_state) return

                const data_dependencies = get_performant_state_reference().data_dependencies
                state.simulation_state.sim_state = update_simulation_state_with_user_action(state.simulation_state.sim_state, data_dependencies, build_action)

                state.simulation_state.sim_state?.built_power_plants.aggregated_by_h3r4["84194a3ffffffff"]
            })
        }
    }
}
